import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface CampaignHistoryDashboardProps {
  product: any | null;
}

const CampaignHistoryDashboard: React.FC<CampaignHistoryDashboardProps> = ({ product }) => {
  // Generate empty rows for the table
  const emptyRows = Array.from({ length: 8 }, (_, index) => ({
    id: index + 1,
    date: '',
    yourName: '',
    newValue: '',
    note: ''
  }));

  if (!product) {
    return (
      <div className="w-full">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl font-bold">Campaign History</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-500">Select a product to view Campaign History.</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="w-full">
      <Card>
        <CardHeader className="p-4">
          <CardTitle className="text-2xl font-bold">Campaign History</CardTitle>
        </CardHeader>
        <CardContent className="p-4">
          {/* Table with frozen header */}
          <div className="w-full border rounded-lg overflow-hidden bg-white dark:bg-gray-900">
            <div className="overflow-auto">
              <table className="w-full border-collapse">
                {/* Header row - sticky */}
                <thead className="sticky top-0 z-20 bg-gray-100 dark:bg-gray-700">
                  <tr>
                    <th className="px-3 py-3 text-left text-sm font-semibold text-gray-700 dark:text-gray-300 border-r border-b min-w-[120px]">
                      Date
                    </th>
                    <th className="px-3 py-3 text-left text-sm font-semibold text-gray-700 dark:text-gray-300 border-r border-b min-w-[150px]">
                      Your Name
                    </th>
                    <th className="px-3 py-3 text-left text-sm font-semibold text-gray-700 dark:text-gray-300 border-r border-b min-w-[150px]">
                      New Value
                    </th>
                    <th className="px-3 py-3 text-left text-sm font-semibold text-gray-700 dark:text-gray-300 border-b min-w-[200px]">
                      Note
                    </th>
                  </tr>
                </thead>

                {/* Data rows */}
                <tbody>
                  {emptyRows.map((row, index) => (
                    <tr key={row.id} className={`hover:bg-gray-50 dark:hover:bg-gray-600 ${index % 2 === 0 ? 'bg-green-50 dark:bg-green-900/20' : 'bg-white dark:bg-gray-800'}`}>
                      {/* Date */}
                      <td className="px-3 py-3 text-sm border-r border-b min-w-[120px]">
                        <span className="text-gray-900 dark:text-gray-100"></span>
                      </td>
                      
                      {/* Your Name */}
                      <td className="px-3 py-3 text-sm border-r border-b min-w-[150px]">
                        <span className="text-gray-900 dark:text-gray-100"></span>
                      </td>
                      
                      {/* New Value */}
                      <td className="px-3 py-3 text-sm border-r border-b min-w-[150px]">
                        <span className="text-gray-900 dark:text-gray-100"></span>
                      </td>
                      
                      {/* Note */}
                      <td className="px-3 py-3 text-sm border-b min-w-[200px]">
                        <span className="text-gray-900 dark:text-gray-100"></span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CampaignHistoryDashboard;